<div class="modal-header">
    <h2 class="modal-title" mat-dialog-title trans>New Project</h2>
    <button type="button" (click)="close()" class="close-button no-style icon-button">
        <svg-icon name="close"></svg-icon>
    </button>
</div>

<form (ngSubmit)="confirm()" ngNativeValidate>
    <div class="mat-dialog-content many-inputs" mat-dialog-content>
        <div class="input-container">
            <label for="project-name" trans>Name</label>
            <input type="text" name="project-name" id="project-name" [(ngModel)]="newProject.name" required>
            <mat-progress-bar mode="indeterminate" *ngIf="loading" color="accent"></mat-progress-bar>
            <p class="error" *ngIf="errors.name">{{errors.name}}</p>
        </div>
    </div>

    <div class="buttons right mat-dialog-actions" mat-dialog-actions>
        <button (click)="close()" type="button" mat-button class="button cancel cancel-button" trans>Cancel</button>
        <button type="submit" mat-raised-button color="accent" class="button primary submit-button" [disabled]="loading" trans>Create</button>
    </div>
</form>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/src/app/dashboard/new-project-page/new-project-modal/new-project-modal.component.html